import React from 'react';
import Button from '../Button/Button';
import messages from './Messages';
import styled from 'styled-components';
import { Chip } from '../AssigneeChip/AssigneeChip';
import Input from '../Input/Input';

interface FullScreenChoiceSelectProps {
  choices: { title: string; value: string }[];
  selected: string[];
  title: string;
  maxCount: number | undefined;
  onSelect: (selected: string[]) => void;
  onDismiss?: () => void;
  loading?: boolean;
}

interface FullScreenChoiceSelectState {
  selected: string[];
  searchText: string;
}

const Wrapper = styled.div`
  position: fixed
  top: 0;
  left:0;
  right:0;
  bottom:0
  padding: 1rem
  background:white
  z-index:2000
  display:flex
  flex-direction: column
`;
const List = styled.div`
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  overflow: auto;
  overflow: overlay;
  height: 90vh;
  align-content: center;
`;

const MyButton = styled(Button)`
  // bottom: 1rem;
  margin: auto;
  // position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
`;

const Title = styled.h5`
  margin: auto;
  text-align: center;
`;

class FullScreenChoiceSelect extends React.Component<
  FullScreenChoiceSelectProps,
  FullScreenChoiceSelectState
> {
  constructor(props: FullScreenChoiceSelectProps) {
    super(props);
    this.state = { selected: [], searchText: '' };
  }

  componentDidMount(): void {
    this.setState({ selected: this.props.selected });
  }
  componentDidUpdate(prevProps: Readonly<FullScreenChoiceSelectProps>): void {
    if (prevProps !== this.props)
      this.setState({ selected: this.props.selected });
  }
  toggleSelected = (choice: string) => {
    let res = this.state.selected;
    const index = res.indexOf(choice);
    if (index >= 0) {
      res.splice(index, 1);
    } else {
      if (this.props.maxCount === 1) {
        res = [choice];
      }
      if (!this.props.maxCount || res.length < this.props.maxCount)
        res.push(choice);
    }
    this.setState({ selected: res });
  };
  render() {
    const { choices, title, maxCount, loading } = this.props;
    const { selected, searchText } = this.state;
    return (
      <Wrapper>
        {loading && (
          <div className="progress">
            <div className="indeterminate" />
          </div>
        )}
        <Title> {title}</Title>
        <Input
          id="search"
          type="text"
          autoComplete="off"
          placeholder={messages.search}
          value={searchText}
          onChange={(e) => {
            this.setState({ searchText: e.target.value });
          }}
        />
        <List>
          {choices
            .filter(
              (c) =>
                selected.includes(c.value) ||
                !searchText ||
                c.title.includes(searchText)
            )
            .map((choice: { title: string; value: string }) => {
              const checked = selected.includes(choice.value);
              return (
                <Chip
                  size={'large'}
                  compact={false}
                  key={choice}
                  hasProgress={false}
                  showPointer={true}
                  selected={checked}
                  disabled={
                    !!maxCount &&
                    selected.length >= maxCount &&
                    !(maxCount === 1)
                  }
                  onClick={() => this.toggleSelected(choice.value)}
                >
                  <span>{choice.title}</span>
                </Chip>
              );
            })}
        </List>
        <div style={{ display: 'flex' }}>
          <MyButton color="green" onClick={() => this.props.onSelect(selected)}>
            {messages.done}
          </MyButton>
          {this.props.onDismiss && (
            <MyButton color="red" onClick={this.props.onDismiss}>
              {messages.close}
            </MyButton>
          )}
        </div>
      </Wrapper>
    );
  }
}

export default FullScreenChoiceSelect;
